// extracted by mini-css-extract-plugin
module.exports = {"node":"tree-node-renderer_node__XMjxy"};